import StyledLink from '../StyledLink'
import {
  SYSTEM,
  TEST_MANAGEMENT_TOOLS
} from '../routes'
import type { Props } from '../types'

const LinkToTestManagementTool = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={`/${SYSTEM}/${TEST_MANAGEMENT_TOOLS}`}
  >
    {children}
  </StyledLink>

export default LinkToTestManagementTool
